import React from 'react'
import NestedPageHero from '../NestedPageHero'
import ContactInfo from '../ContactInfo'
import ContactForm from '../ContactForm'

function Contact() {
  return (
    <div>
        <NestedPageHero title={'Contact Us'}/>
        <ContactInfo/>
        <ContactForm/>
    </div>
  )
}

export default Contact